var render = function render(){var _vm=this,_c=_vm._self._c;return (! _vm.confirmed)?_c('div',{staticClass:"alert"},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.msg)+"\n    "),_c('i',{staticClass:"material-icons close",on:{"click":function($event){_vm.confirmed = true}}},[_vm._v("close")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }